import React from 'react'
import { Grid, TextField, Typography, FormControl, RadioGroup, FormControlLabel, Radio, InputAdornment, Tooltip, Fab } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import AddIcon from '@material-ui/icons/Add'
import { SelecionarData } from 'components'

const estadoCivilOptions = [
  'Solteiro (a)',
  'União Estável',
  'Casado (a)',
  'Separado (a)',
  'Divorciado (a)',
  'Viúvo (a)',
  'Outro (a)',
]

export const FormDadosGerais = (props) => {
  const {
    formPericiando,
    paises,
    estados,
    cidadesNaturalidade,
    arrayFiliacoesPericiando,
    handleAdicionarFiliacao,
    handleChangeNaturalidadeEstado,
    cpfMask,
    classes,
  } = props

  return (
    <Grid container spacing={2} className={classes.fieldGroup}>
      {/* CPF & RG */}
      <Grid container item xs={12} justifyContent="space-between" spacing={2}>
        <Grid item md={5} sm={5} xs={12}>
          <TextField
            error={formPericiando.hasError('cpf')}
            fullWidth
            helperText={formPericiando.hasError('cpf') ? formPericiando.formState.errors.cpf[0] : null}
            label="CPF"
            name="cpf"
            onChange={(e) => formPericiando.handleChangeWithModification(e, cpfMask)}
            value={formPericiando.formState.values.cpf || ''}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item md={5} sm={5} xs={12}>
          <TextField
            error={formPericiando.hasError('rg')}
            fullWidth
            helperText={formPericiando.hasError('rg') ? formPericiando.formState.errors.rg[0] : null}
            label="RG"
            name="rg"
            onChange={formPericiando.handleChange}
            value={formPericiando.formState.values.rg || ''}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>

      {/* Estado Civil & Nacionalidade */}
      <Grid container item xs={12} justifyContent="space-between" spacing={2}>
        <Grid item md={5} sm={5} xs={12}>
          <AutocompleteNative
            value={formPericiando.formState.values.estadoCivil || null}
            name="estadoCivil"
            noOptionsText="Sem informações"
            options={estadoCivilOptions}
            getOptionSelected={(option, value) => option.nome === value}
            onChange={(event, newValue) => {
              formPericiando.handleChangeNewValueByNameProperty(event, newValue, 'estadoCivil')
            }}
            getOptionLabel={(option) => `${option}`}
            renderOption={(option) => `${option}`}
            renderInput={(params) => (
              <TextField
                {...params}
                label="ESTADO CIVIL"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>
      
        <Grid item md={5} sm={5} xs={12}>
          <AutocompleteNative
            name="nacionalidade"
            fullWidth
            getOptionLabel={(option) => {
              if (typeof option === 'string') return option
              return option?.nome || ''
            }}
            value={formPericiando.formState.values.nacionalidade || null}
            noOptionsText="Sem informações"
            options={paises}
            getOptionSelected={(option, value) => {
              const optionNome = option?.nome?.toUpperCase() || ''
              const valueNome = typeof value === 'string' ? value.toUpperCase() : (value?.nome?.toUpperCase() || '')
              return optionNome === valueNome
            }}
            onChange={(event, newValue) => {
              formPericiando.handleChangeNewValueByNameProperty(event, newValue, 'nacionalidade')
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="NACIONALIDADE"
                placeholder="Selecionar..."
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>
      </Grid>

      {/* Estado da Naturalidade & Cidade da Naturalidade */}
      <Grid container item xs={12} justifyContent="space-between" spacing={2}>
        <Grid item md={5} sm={5} xs={12}>
          <AutocompleteNative
            name="naturalidade"
            fullWidth
            getOptionLabel={(option) => {
              if (typeof option === 'string') return option
              return option?.nome || option?.sigla || ''
            }}
            value={formPericiando.formState.values.naturalidade || null}
            noOptionsText="Sem informações"
            options={estados}
            getOptionSelected={(option, value) => {
              const optionSigla = option?.sigla?.toUpperCase() || ''
              const valueSigla = typeof value === 'string' ? value.toUpperCase() : (value?.sigla?.toUpperCase() || '')
              return optionSigla === valueSigla
            }}
            onChange={handleChangeNaturalidadeEstado}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="ESTADO DA NATURALIDADE"
                placeholder="Selecionar..."
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>
        <Grid item md={5} sm={5} xs={12}>
          <AutocompleteNative
            name="naturalidadeCidade"
            fullWidth
            disabled={!formPericiando.formState.values.naturalidade}
            getOptionLabel={(option) => {
              if (typeof option === 'string') return option
              return option?.nome || ''
            }}
            value={formPericiando.formState.values.naturalidadeCidade || null}
            noOptionsText="Sem informações"
            options={cidadesNaturalidade}
            getOptionSelected={(option, value) => {
              const optionNome = option?.nome?.toUpperCase() || ''
              const valueNome = typeof value === 'string' ? value.toUpperCase() : (value?.nome?.toUpperCase() || '')
              return optionNome === valueNome
            }}
            onChange={(event, newValue) => {
              formPericiando.handleChangeNewValueByNameProperty(event, newValue, 'naturalidadeCidade')
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="CIDADE DA NATURALIDADE"
                placeholder="Selecionar..."
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>
      </Grid>

      {/* Data Nascimento & Sexo */}
      <Grid container item xs={12} justifyContent="space-between" alignItems="center" spacing={2}>
        <Grid item md={5} sm={5} xs={12}>
          <SelecionarData
            md={12}
            sm={12}
            xs={12}
            dataBD={formPericiando.formState.values.dataNascimento}
            callback={(dataNascimento) => formPericiando.handleChangeCampoData('dataNascimento', dataNascimento)}
            label="DATA DE NASCIMENTO"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            withoutTime
          />
        </Grid>
        <Grid item md={5} sm={5} xs={12}>
          <Grid item xs={12}>
            <Typography variant="body2">SEXO</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                aria-label="sexo"
                name="sexo"
                value={formPericiando.formState.values.sexo || null}
                onChange={formPericiando.handleChange}
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                <FormControlLabel value="MASCULINO" control={<Radio />} label={<Typography variant="body2">MASCULINO</Typography>} />
                <FormControlLabel value="FEMININO" control={<Radio />} label={<Typography variant="body2">FEMININO</Typography>} />
                <FormControlLabel value="DESCONHECIDO" control={<Radio />} label={<Typography variant="body2">DESCONHECIDO</Typography>} />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>

      {/* Nome Completo & Alcunha */}
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="NOME COMPLETO"
          required
          name="nome"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={formPericiando.handleChange}
          value={formPericiando.formState.values.nome || ''}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="ALCUNHA"
          name="alcunha"
          required
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={formPericiando.handleChange}
          value={formPericiando.formState.values.alcunha || ''}
        />
      </Grid>

      <Grid item md={12} sm={12} xs={12}>
        <TextField
          fullWidth
          label="NOME SOCIAL"
          name="nomeSocial"
          required
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={formPericiando.handleChange}
          value={formPericiando.formState.values.nomeSocial || ''}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" color="error">
          (* É obrigatório fornecer o NOME COMPLETO, NOME SOCIAL ou ALCUNHA)
        </Typography>
      </Grid>

      {/* Filiações dinâmicas */}
      <Grid item xs={12}>
        {arrayFiliacoesPericiando.map((input, index) => (
          <TextField
            key={input}
            error={formPericiando.hasError(input)}
            fullWidth
            helperText={formPericiando.hasError(input) ? formPericiando.formState.errors[input][0] : null}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            className={classes.inputForm}
            label={`FILIAÇÃO (${index + 1})`}
            name={input}
            onChange={formPericiando.handleChange}
            value={formPericiando.formState.values[input] || ''}
            InputProps={{
              endAdornment: index + 1 === arrayFiliacoesPericiando.length && (
                <InputAdornment position="start">
                  <Tooltip title="Adicionar filiação">
                    <Fab
                      color="primary"
                      size="small"
                      onClick={handleAdicionarFiliacao}
                      className={classes.botaoAddFiliacao}
                    >
                      <AddIcon />
                    </Fab>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
        ))}
      </Grid>
    </Grid>
  )
}
